import axios from "@/plugins/axios";

let url = "/api/plugins/wpay";

export const wpay = {
    /**
     * 결제 시작 — 회원 진행 상태에 맞는 첫 화면(회원가입/계좌등록/결제인증) 폼을 받는다.
     * 응답 { checkout: { url, params } } 을 자동제출 폼으로 이니시스 결제창(새창)에 전송한다.
     * @param {{ orderNo: string, ci: string }} data
     * @returns {Promise<{ success: boolean, checkout: { url: string, params: object } }>}
     */
    request(data) {
        return axios.post(`${url}/request`, data).then((result) => result.data);
    },

    /**
     * 회원설정 마이페이지(3.22) — 계좌 등록·삭제, 비밀번호 변경, 회원탈퇴를 하는 이니시스 화면 폼을 받는다.
     * 로그인 회원 본인의 이니시스 회원키가 있어야 한다.
     * @returns {Promise<{ success: boolean, checkout: { url: string, params: object } }>}
     */
    mypage: {
        request() {
            return axios.post(`${url}/mypage/request`).then((result) => result.data);
        },
    },
};
